import { ItemDeliveryStats, Operation } from "../state/types"
import { TableName } from "../../../tables"
import { useOperationLoaders } from "../loaders/operationLoaders"
import { useOperationBuilders } from "../builders/operationBuilders"
import { useOperationActions } from "../actions/operationActions"

export const useOperationService = () => {
    const { buildOperation, buildItemDeliveryStats } = useOperationBuilders()

    const operationLoaders = useOperationLoaders()

    const { saveOperation } = useOperationActions()

    const updateOperationProps = async (
        table: TableName,
        operationId: string,
        props: Partial<Operation>,
    ) => {
        const { loadOperation } = operationLoaders()
        const loadedOperation = await loadOperation(table, operationId, true)

        const operation = buildOperation(table, {
            ...loadedOperation!,
            ...props
        })!

        return saveOperation(table, operation)
    }

    const updateDeliveryStats = async (
        table: TableName,
        operationId: string,
        diffMap: Map<string, Partial<ItemDeliveryStats>>,
        props: Partial<Operation> = {}
    ) => {
        const { loadOperation } = operationLoaders()
        const loadedOperation = await loadOperation(table, operationId, true)

        const items = props.items || loadedOperation!.items
        const newItems = items.map(item => {
            const { deliveryStats } = item
            const diff = diffMap.get(item.id)
            const { toBeEmitted = 0, pending = 0, emitted = 0 } = diff || {}
            return {
                ...item,
                deliveryStats: buildItemDeliveryStats({
                    toBeEmitted: deliveryStats!.toBeEmitted + toBeEmitted,
                    pending: Math.max(0, deliveryStats!.pending + pending),
                    emitted: Math.max(0, deliveryStats!.emitted + emitted)
                })
            }
        })

        return updateOperationProps(table, operationId, {
            ...props,
            items: newItems
        })
    }

    return {
        updateOperationProps,
        updateDeliveryStats
    }
}
